import React from "react";
import { UiBannerBottomBar } from "../../../components/common/UiBannerBottomBar";
import UiMainWrapper from "../../../components/common/UiMainWrapper";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiRowContainer } from "../../../components/grid-container/GridContainer";
import TopHeader from "../../../components/header/TopHeader";
import KnowledgeInnerBaner from "../Views/KnowledgeInnerBanner";
import { QuizzerCard } from "../Views/QuizzerCard";
import quizAllBanner from "../../../../../styles/img/quiz-all-banner.png";
import volvoLogo from '../../../../../styles/img/volvo-logo-round.png';
import Footer from "../../../components/footer/Footer";

export const ViewQuizzersBadgesCompleted = (props) => {
    return (
        <>

            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBaner
                    title="Learning History"
                    description="See what courses you’ve completed!"
                    sliderCardImage={quizAllBanner}
                    className="sb-knowldg-inner-banner" />


                <UiBannerBottomBar
                    prevPage="Knowledge"
                    prevPageLink="/ui"
                    currentPage="  Learning History"
                    currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-quizzers-all-sec">
                        <UiContentCol>
                            <div className="sb-quizzers-all-sec__nav">
                                <div className="sb-quizzers-all-sec-nav-link "> All Quizzes </div>
                                <div className="sb-quizzers-all-sec-nav-link "> In-Progress </div>
                                <div className="sb-quizzers-all-sec-nav-link active"> Completed </div>
                            </div>


                            <QuizzerCard
                                expand={true}
                                status="completed"
                                title="Quiz Name"
                                image={volvoLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                            />

                            <QuizzerCard
                                status="completed"
                                title="Quiz Name"
                                image={volvoLogo}
                                description="Lorem epsum to start badge priority lorem epsum Lorem epsum to start badge priority lorem epsum, Lorem epsum to start badge priority lorem epsum Lorem epsum to"
                            />

                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <Footer />

            </UiMainWrapper>


        </>
    )
}